import * as React from "react";
import {cx} from "emotion";

import "./print-table.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

export const PrintTable = ({columns, rows}) => cs(
    () => (
        <table className="print-table print-table-7fe" cellSpacing={0} cellPadding={0}>
            <colgroup>
                {columns.map((col, i) => (
                    <col
                        key={i}
                        // width={col.width}
                        style={{width: col.width}}
                    />
                ))}
            </colgroup>
            <thead>
            <tr>
                {columns.map((column, i) => (
                    <th {...{
                        key: i,
                        className: cx(
                            column.className, 
                            column.align && "align-" + column.align,
                            column.padding && "padding-" + column.padding
                        ),
                    }}>
                        {column.label}
                    </th>
                ))}
            </tr>
            </thead>

            <tbody>
            {rows.map((row, i) => cs(
                keyed(row.key ?? i),
                () => (
                    <tr>
                        {row.columns.map((col, ci) => (
                            <td
                                className={cx(
                                    col.className,
                                    columns[ci].className,
                                    columns[ci].align && "align-" + columns[ci].align,
                                )}
                                key={ci}
                                colSpan={col.colSpan}
                            >
                                {col.render()}
                            </td>
                        ))}
                    </tr>
                ),
            ))}
            </tbody>
        </table>
    ),
);
